import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import { Card, DescriptionList } from '@applyboard/crystal-ui';
import { formatDate } from '@applyboard/ui-utils';
import { formatTimelessDateStr } from "../../utils/dates";
import { capitalize } from 'lodash';
import { replaceUnderscoresWithSpace } from "../../utils/formatUnderscores";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var IntakeInfoCard = function IntakeInfoCard(_ref) {
  var intakes = _ref.intakes,
    intakeId = _ref.intakeId,
    ariaLabel = _ref['aria-label'],
    hideDates = _ref.hideDates;
  var selectedIntake = intakes.find(function (intake) {
    return intake.intakeId.toString() === intakeId.toString();
  });
  if (!selectedIntake) {
    return null;
  }
  return _jsx(Card, {
    "aria-label": ariaLabel,
    children: _jsxs(DescriptionList, {
      variant: "grid",
      children: [_jsx(DescriptionList.Item, {
        term: "Intake status",
        details: capitalize(replaceUnderscoresWithSpace(selectedIntake.intakeStatus)),
        align: "start",
        justify: "start"
      }), !hideDates && selectedIntake.submissionDeadline && (selectedIntake.openDate ? _jsx(DescriptionList.Item, {
        term: "Accepting applications",
        details: "".concat(formatTimelessDateStr(selectedIntake.openDate, 'MMM Do, YYYY'), " - ").concat(formatDate(selectedIntake.submissionDeadline, 'MMM Do, YYYY')),
        align: "start",
        justify: "start"
      }) : _jsx(DescriptionList.Item, {
        term: "Submission deadline",
        details: formatDate(selectedIntake.submissionDeadline, 'MMM Do, YYYY'),
        align: "start",
        justify: "start"
      }))]
    })
  });
};